<template functional>
  <div class="skeleton">
    <div class="skeleton-topbar">
      <div class="skeleton-item topbar-logo"></div>
      <div class="skeleton-item topbar-search"></div>
      <div class="topbar-menu">
        <div class="skeleton-item" v-for="item in [1,2,3]" :key="item"></div>
      </div>
    </div>
    <div class="skeleton-item skeleton-block"></div>
    <div class="skeleton-list">
      <div class="skeleton-item" v-for="item in [1,2,3,4,5]" :key="item"></div>
    </div>
    <div class="skeleton-list">
      <div class="skeleton-item" v-for="item in [1,2,3,4,5]" :key="item"></div>
    </div>
    <div class="skeleton-item skeleton-block-middle"></div>
    <div class="skeleton-list">
      <div class="skeleton-item" v-for="item in [1,2,3,4,5]" :key="item"></div>
    </div>
    <div class="skeleton-part">
      <div v-for="item in [1,2]" :key="item">
        <div class="skeleton-item skeleton-part-large"></div>
        <div class="skeleton-item skeleton-part-small"></div>
        <div class="skeleton-item skeleton-block-small"></div>
      </div>
    </div>
    <div class="skeleton-list">
      <div class="skeleton-item skeleton-list-big" v-for="item in [1,2,3,4]" :key="item"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeSkeleton'
}
</script>

<style scoped lang="scss">
.skeleton{
  padding: .24rem;
}

.skeleton-item{
  background: #f5f5f5;
  animation: skeleton 1.2s ease-in-out infinite;
}

.skeleton-topbar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .topbar-logo{
    width: 1.02rem;
    height: .72rem;
    border-radius: .36rem;
  }
  .topbar-search{
    width: 3.08rem;
    height: .72rem;
    border-radius: .36rem;
  }
  .topbar-menu{
    display: flex;
    div{
      margin-left: .16rem;
      width: .68rem;
      height: .68rem;
      border-radius: .36rem;
    }
  }
}

.skeleton-block{
  margin: .28rem 0;
  height: 2.8rem;
  border-radius: .24rem;
}

.skeleton-block-middle{
  margin: .28rem 0;
  height: 1.7rem;
  border-radius: .24rem;
}

.skeleton-list{
  margin: 0 .3rem;
  padding: .16rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    width: .84rem;
    height: .84rem;
    border-radius: .24rem;
  }
  .skeleton-list-big{
    width: 1.46rem;
    height: 1.46rem;
  }
}

.skeleton-part{
  margin: 0 .3rem;
  display: flex;
  justify-content: space-between;
}

.skeleton-part-large{
  margin: .3rem 0;
  width: 3.08rem;
  height: .36rem;
  border-radius: .12rem;
}

.skeleton-part-small{
  margin: .3rem 0;
  width: 1.96rem;
  height: .36rem;
  border-radius: .12rem;
}

.skeleton-block-small{
  margin: .3rem 0;
  width: 3.08rem;
  height: .96rem;
  border-radius: .12rem;
}

@keyframes skeleton {
  50%{
    opacity: .6;
  }
}

</style>
